import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { GetQuery } from './Shared';

interface JobScheduleFencingProps {
    jobId: number;     //use job quote item id as I want to get all scheduled void items
    showModal: boolean;
    hideModal(): void;
    saveModal(): void;
}

interface FenceItemDetail {
    jobQuoteItemId: number;
    description: string;
    fencePanels: number;
    fencePanelsDamaged: number;
    fenceBlocks: number;
    fenceClamps: number;
    fencePickets: number;
    fenceSigns: number;
    fenceBraces: number;
    isOnSite: boolean;
    isTotal: boolean;
}

const JobScheduleFencingModalData = (props: JobScheduleFencingProps) => {
    const [loading, setLoading] = React.useState(false);
    const [fenceItems, setFenceItems] = React.useState<FenceItemDetail[]>([]);

    React.useEffect(() => {
        if (props.showModal) {
            setLoading(true);
            getData();
        }
    }, [props.showModal]);

    const getData = async () => {
        const apiUrl = 'GetScheduleFencingDetails?JobId=' + props.jobId;
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            setFenceItems(result.data);
            setLoading(false);
        }
    }

    const hideModal = () => {
        setLoading(false);
        setFenceItems([]);
        props.hideModal();
    }

    const renderDetails = (
        <div className="static-modal">
            <Modal size="xl" show={props.showModal} onHide={hideModal}>
                <Modal.Header className="modal__header--colour">
                    <Modal.Title>Fencing Details</Modal.Title>
                    <button type="button" className="close" onClick={hideModal}>&times;</button>
                </Modal.Header>
                <Modal.Body>
                    <table className="table">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Panels</th>
                                <th>Panels Damaged</th>
                                <th>Blocks</th>
                                <th>Clamps</th>
                                <th>Pickets</th>
                                <th>Signs</th>
                                <th>Braces</th>
                            </tr>
                        </thead>
                        <tbody>
                            {fenceItems.map((item, index) =>
                                <tr key={index} className={item.isOnSite ? "tableColours--install" : item.isTotal ? "tableColours--install-ph" : "" }>
                                    <td className="table__text--align">{item.description}</td>
                                    <td className="table__text--align">{item.fencePanels}</td>
                                    <td className="table__text--align">{item.fencePanelsDamaged}</td>
                                    <td className="table__text--align">{item.fenceBlocks}</td>
                                    <td className="table__text--align">{item.fenceClamps}</td>
                                    <td className="table__text--align">{item.fencePickets}</td>
                                    <td className="table__text--align">{item.fenceSigns}</td>
                                    <td className="table__text--align">{item.fenceBraces}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </Modal.Body>
            </Modal>
        </div>
    );

    let contents = !props.showModal ? "" :
        loading ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            {contents}
        </div>
    );
}

export default JobScheduleFencingModalData;